import { request } from '@/util/http'

export const getDetail = (current, size, params) => {
  return request({
    url: '/health/healthPublicity/detail',
    method: 'get',
    params: {
      ...params,
      current,
      size
    }
  })
}

export const getList = (current, size, params) => {
  return request({
    url: '/health/healthPublicity/getList',
    method: 'get',
    params: {
      ...params,
      current,
      size
    }
  })
}

export const submit = (params) => {
  return request({
    url: '/health/healthPublicity/submit',
    method: 'post',
    params: {
      ...params
    }
  })
}

export const update = (row) => {
  return request({
    url: '/health/healthPublicity/update',
    method: 'post',
    data: row
  })
}

export const remove = (ids) => {
  return request({
    url: '/health/healthPublicity/remove',
    method: 'post',
    params: {
      ids
    }
  })
}
